<template>
  <div class="myChoicePublic">
    <div class="myChoicePublic-header">
      <!--        <el-row class="row-one">-->
      <!--          <span class="row-one-title">添加基金</span>-->
      <!--          <span class="row-one-fr" @click="gotoRank()">全部基金排行</span>-->
      <!--        </el-row>-->
      <el-form :model="formAddChoice" class="form-single-inline margin-t20 fl" :inline="true">
        <el-form-item label="">
          <el-select filterable placeholder="请输入基金代码/拼音/简称" style="width: 220px;" :filter-method="searchFunds" v-model="formAddChoice.code" clearable>
            <el-option v-for="item in searchFundList" :key="item.code" :label="item.name" :value="item.code">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="添加至：">
          <el-select v-model="formAddChoice.choiceType" placeholder="请选择自选分类">
            <el-option v-for="(item,ind) in choiceTypeList" :key="ind+'fenlei'" :label="item.GroupName" :value="item.GroupCode">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="search" @click="addFundFun">添加</el-button>
        </el-form-item>
      </el-form>
      <span class="myChoicePublic-header-link margin-t20 fl" @click="gotoRank()">全部基金排行</span>
      <span class="myChoicePublic-header-refresh" @click="iconClick"><i :class="[refresh? 'el-icon-refresh go' : 'el-icon-refresh']"></i> 刷新</span>
      <el-button type="search" class="myChoicePublic-set" @click="dialogVisable = true" style="border-radius:4px;"> <i class="el-icon-plus"></i> 设置自选</el-button>
    </div>
    <template v-for="(item,index) in allData">
      <div class="common-box" :key="index+'group'">
        <el-row class="row-one">
          <span class="row-one-title">{{item.groupName}}</span>
          <span class="row-one-span"> (开放式基金)</span>
        </el-row>
        <div class="margin-t20">
          <el-radio-group v-model="item.fundChoice" class="radio-single-btn">
            <el-radio-button label="0">基金概况</el-radio-button>
            <el-radio-button label="1">业绩排名</el-radio-button>
          </el-radio-group>
          <div class="fr margin-t5 myChoicePublic-fontopt">
            <img v-if="fontSize==18" src="@/assets/images/font_add_dis.png" alt="">
            <img v-else src="@/assets/images/font_add.png" alt="" class="imgs" @click="fontopt('add')">
            <img v-if="fontSize==14" src="@/assets/images/font_cut_dis.png" alt="">
            <img v-else src="@/assets/images/font_cut.png" alt="" class="imgs" @click="fontopt('cut')">
          </div>
          <div class="fr margin-t5">
            <el-button type="simple" @click="optFunds(index,item.fundChoice,'delete')">删除</el-button>
            <el-button type="simple" @click="optFunds(index,item.fundChoice,'diagnosis')">诊断</el-button>
          </div>
        </div>
        <el-table v-show="item.fundChoice==0" :data="item.fundProfile" :class="['table-single',{'font16':fontSize==16},{'font18':fontSize==18},'margin-t20']" :key="index+'jjgktab'" @selection-change="(val) => handleSelectionChange(index,item.fundChoice, val) ">
          <el-table-column type="selection" width="45" fixed="left"></el-table-column>
          <el-table-column label="基金代码" prop="fundCode" width="95" fixed="left">
            <template slot-scope="scope">
              <a style="text-align: left;" :href="'https://www.myfund.com/mutualfund/'+ scope.row.fundCode +'.html'" class="table-single-a" target="_blank">{{scope.row.fundCode}}</a>
            </template>
          </el-table-column>
          <el-table-column label="基金名称" prop="fundName" width="150" fixed="left">
            <template slot-scope="scope">
              <el-tooltip class="item" effect="light" popper-class="table-single-tip" :content="scope.row.fundName" placement="right">
                <a style="text-align: left;" :href="'https://www.myfund.com/mutualfund/'+ scope.row.fundCode +'.html'" class="table-single-a" target="_blank">{{scope.row.fundName}}</a>
              </el-tooltip>
              <!-- <p class="table-single-p" :title="scope.row.fundName">{{scope.row.fundName}}</p> -->
            </template>
          </el-table-column>
          <el-table-column label="净值日期" prop="netValueDate" width="150"></el-table-column>
          <el-table-column label="净值估算" prop="netWorth" width="100">
            <template slot-scope="scope">
              <span :class="[{'rColor':parseFloat(scope.row.netWorth)>0},{'gColor':parseFloat(scope.row.netWorth)<0}]">{{scope.row.netWorth}}</span>
            </template>
          </el-table-column>
          <el-table-column label="估算涨幅" prop="estimatedIncrease" width="100">
            <template slot-scope="scope">
              <span :class="[{'rColor':parseFloat(scope.row.estimatedIncrease)>0},{'gColor':parseFloat(scope.row.estimatedIncrease)<0}]">{{scope.row.estimatedIncrease}}</span>
            </template>
          </el-table-column>
          <el-table-column label="日增长值" prop="dailyGrowth" width="100">
            <template slot-scope="scope">
              <span :class="[{'rColor':parseFloat(scope.row.dailyGrowth)>0},{'gColor':parseFloat(scope.row.dailyGrowth)<0}]">{{scope.row.dailyGrowth}}</span>
            </template>
          </el-table-column>
          <el-table-column label="单位净值" prop="unitNet" width="140"></el-table-column>
          <el-table-column label="累计净值" prop="accumulatedNet" width="100"></el-table-column>
          <el-table-column label="添加以来收益率" prop="yields" width="145">
            <template slot-scope="scope">
              <span :class="[{'rColor':parseFloat(scope.row.yields)>0},{'gColor':parseFloat(scope.row.yields)<0}]">{{scope.row.yields}}</span>
            </template>
          </el-table-column>
          <el-table-column label="添加时间" prop="addDate" width="130"></el-table-column>
          <el-table-column label="操作" prop="" fixed="right" width="220">
            <template slot-scope="scope">
              <span class="table-single-btn-font" @click="buyFunds(scope.row)">购买</span>
              <span v-if="item.fundProfilePage==1 && scope.$index==0" style="margin-left:0;" class="table-single-btn-fontdis">置顶</span>
              <span v-else class="table-single-btn-font" style="margin-left:0;" @click="goTopFun(index,item.groupCode,scope.row.fundCode)">置顶</span>
              <span v-if="item.groupOthers.length==0" class="table-single-btn-fontdis" style="margin-left:0;">移动分类自选</span>
              <el-dropdown v-else :class="['dropdown-x',{'font16':fontSize==16},{'font18':fontSize==18}]" trigger="click" @command="(command)=>moveOtherGroup(command,scope.row.fundCode,index,item)">
                <span class="el-dropdown-link">移动分类自选</span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item v-for="(v,i) in item.groupOthers" :key="i" :command="v">{{v.GroupName}}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination class="pagination-single" v-show="item.fundChoice==0" @current-change="(val) => handleCurrentChange(index,item.fundChoice, val)" :current-page.sync="item.fundProfilePage" :page-size="item.fundProfilePageNum" layout="prev, pager, next" :total="item.fundProfileTotal" hide-on-single-page :key="index+'jjgkpag'">
        </el-pagination>
        <el-table v-show="item.fundChoice==1" :data="item.fundRank" :class="['table-single',{'font16':fontSize==16},{'font18':fontSize==18},'margin-t20']" :key="index+'yjpmtab'" @selection-change="(val) => handleSelectionChange(index,item.fundChoice, val) " @sort-change="(column)=>changeTableSort(column,index)" :default-sort="{prop: 'sinceThisYear', order: 'descending'}">
          <el-table-column type="selection" width="45"></el-table-column>
          <el-table-column label="基金代码" prop="fundCode" width="95">
            <template slot-scope="scope">
              <a style="text-align: left;" :href="'https://www.myfund.com/mutualfund/'+ scope.row.fundCode +'.html'" class="table-single-a" target="_blank">{{scope.row.fundCode}}</a>
            </template>
          </el-table-column>
          <el-table-column label="基金名称" prop="fundName" width="150">
            <template slot-scope="scope">
              <el-tooltip class="item" effect="light" popper-class="table-single-tip" :content="scope.row.fundName" placement="right">
                <a style="text-align: left;" :href="'https://www.myfund.com/mutualfund/'+ scope.row.fundCode +'.html'" class="table-single-a" target="_blank">{{scope.row.fundName}}</a>
              </el-tooltip>
              <!-- <p class="table-single-p" :title="scope.row.fundName">{{scope.row.fundName}}</p> -->
            </template>
          </el-table-column>
          <el-table-column label="今年以来" prop="sinceThisYear" sortable="custom" width="100" :sort-orders="sortOrders">
            <template slot-scope="scope">
              <span :class="[{'rColor':parseFloat(scope.row.sinceThisYear)>0},{'gColor':parseFloat(scope.row.sinceThisYear)<0}]">{{scope.row.sinceThisYear}}</span>
            </template>
          </el-table-column>
          <el-table-column label="近1周" prop="oneWeek" sortable="custom" :sort-orders="sortOrders">
            <template slot-scope="scope">
              <span :class="[{'rColor':parseFloat(scope.row.oneWeek)>0},{'gColor':parseFloat(scope.row.oneWeek)<0}]">{{scope.row.oneWeek}}</span>
            </template>
          </el-table-column>
          <el-table-column label="近1月" prop="oneMonth" sortable="custom" :sort-orders="sortOrders">
            <template slot-scope="scope">
              <span :class="[{'rColor':parseFloat(scope.row.oneMonth)>0},{'gColor':parseFloat(scope.row.oneMonth)<0}]">{{scope.row.oneMonth}}</span>
            </template>
          </el-table-column>
          <el-table-column label="近3月" prop="threeMonth" sortable="custom" :sort-orders="sortOrders">
            <template slot-scope="scope">
              <span :class="[{'rColor':parseFloat(scope.row.threeMonth)>0},{'gColor':parseFloat(scope.row.threeMonth)<0}]">{{scope.row.threeMonth}}</span>
            </template>
          </el-table-column>
          <el-table-column label="近6月" prop="sixMonth" sortable="custom" :sort-orders="sortOrders">
            <template slot-scope="scope">
              <span :class="[{'rColor':parseFloat(scope.row.sixMonth)>0},{'gColor':parseFloat(scope.row.sixMonth)<0}]">{{scope.row.sixMonth}}</span>
            </template>
          </el-table-column>
          <el-table-column label="近1年" prop="oneYear" sortable="custom" :sort-orders="sortOrders">
            <template slot-scope="scope">
              <span :class="[{'rColor':parseFloat(scope.row.oneYear)>0},{'gColor':parseFloat(scope.row.oneYear)<0}]">{{scope.row.oneYear}}</span>
            </template>
          </el-table-column>
          <el-table-column label="近2年" prop="twoYear" sortable="custom" :sort-orders="sortOrders">
            <template slot-scope="scope">
              <span :class="[{'rColor':parseFloat(scope.row.twoYear)>0},{'gColor':parseFloat(scope.row.twoYear)<0}]">{{scope.row.twoYear}}</span>
            </template>
          </el-table-column>
          <el-table-column label="近3年" prop="threeYear" sortable="custom" :sort-orders="sortOrders">
            <template slot-scope="scope">
              <span :class="[{'rColor':parseFloat(scope.row.threeYear)>0},{'gColor':parseFloat(scope.row.threeYear)<0}]">{{scope.row.threeYear}}</span>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination class="pagination-single" v-show="item.fundChoice==1" @current-change="(val) => handleCurrentChange(index,item.fundChoice, val)" :current-page.sync="item.fundRankPage" :page-size="item.fundRankPageNum" layout="prev, pager, next" :total="item.fundRankTotal" hide-on-single-page :key="index+'yjpmpag'">
        </el-pagination>
      </div>
    </template>
    <!--   弹框：自选设置-->
    <el-dialog class="dialog-single-two" title="自选分类" :visible.sync="dialogVisable">
      <el-form class="form-single-inline margin-t20" :inline="true">
        <el-form-item label="新建：">
          <el-input v-model="addChoiceItem" placeholder="自定义自选"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="search" @click="addChoiceItemSure()">确定</el-button>
        </el-form-item>
      </el-form>
      <el-table class="table-single margin-t10" :data="choiceTypeTable" max-height="183px">
        <el-table-column label="分类名称" prop="GroupName"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <template v-if="scope.row.GroupCode==0">
              <span class="table-single-btn-forbid1">不可更改</span>
            </template>
            <template v-else>
              <span class="table-single-btn-normal" @click="choiceTypeItemEdit(scope.row)">更名</span>
              <span class="table-single-btn-normal" @click="choiceTypeItemDel(scope.row)">删除</span>
              <span class="table-single-btn-forbid1" v-if="scope.$index==1">上移</span>
              <span class="table-single-btn-normal" v-else @click="moveUp(scope.$index)">上移</span>
              <span class="table-single-btn-forbid1" v-if="scope.$index==(choiceTypeTable.length-1)">下移</span>
              <span class="table-single-btn-normal" v-else @click="moveDown(scope.$index)">下移</span>
            </template>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <!--弹框：自选设置—更名 -->
    <el-dialog class="dialog-single-three" :visible.sync="dialogVisable1" :show-close="false">
      <div class="dialog-single-three-p">更改自选分类名称</div>
      <el-input class="margin-t20" v-model="choiceTypeItemName" placeholder="请填写自定义名称"></el-input>
      <div class="margin-t30">
        <el-button type="normal1" @click="choiceTypeItemEditSure()">更改</el-button>
        <el-button type="cancel" style="width:154px" @click="dialogVisable1 = false">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { Message } from 'element-ui';
export default {
  name: "myChoicePublic",
  data () {
    return {
      userCode: '',
      searchFundList: [],
      formAddChoice: {
        code: '',
        choiceType: '0'
      },
      refresh: false,
      choiceTypeList: [],
      // 自选设置
      dialogVisable: false,
      addChoiceItem: '',
      choiceTypeTable: [],
      choiceTypeTableCodes: [],
      // 自选分类 更名
      choiceTypeItemCode: '',
      choiceTypeItemName: '',
      dialogVisable1: false,
      // 所有数据
      allData: [],
      // 排序
      sortOrders: ['ascending', 'descending'],
      // 字体大小
      fontSize: 14,
    }
  },
  created () {
    this.userCode = this.$commonJs.getCookie('u_phone1');
  },
  mounted () {
    this.getChoiceType();
  },
  methods: {
    // 刷新
    iconClick () {
      this.getChoiceType();
      this.refresh = !this.refresh;
      setTimeout(() => {
        this.refresh = !this.refresh;
      }, 1000)

    },
    // 字体放大、缩小
    fontopt (type) {
      if (type == 'add') {
        this.fontSize = this.fontSize + 2;
      } else {
        this.fontSize = this.fontSize - 2;
      }
    },

    // 基金排行
    gotoRank () {
      var p = window.location.protocol;  // 获取协议
      window.open(p + "//www.myfund.com/fundrank.html", "_blank");
    },
    // 搜索基金
    searchFunds (val) {
      const vm = this;
      if (val) {
        vm.$http.get(vm.$apiPath.searchFund, {
          user: 'admin',
          flag: 'all',
          info: val,
          type: '公募'
        }).then(res => {
          if (res.data.Result) {
            vm.searchFundList = [];
            if (res.data.fundlist && res.data.fundlist.length > 0) {
              let sdata = res.data.fundlist;
              sdata.forEach((val, ind) => {
                vm.searchFundList.push({
                  code: val.fundCode,
                  name: val.fundName
                })
              })
            }
          }
        })
      }
    },
    // 添加搜索基金
    addFundFun () {
      const vm = this;
      if (vm.formAddChoice.code) {
        // 先清除已存在的情况
        vm.$http.get(vm.$apiPath.delFundCodes, {
          userCode: vm.userCode,
          groupCode: vm.formAddChoice.choiceType,
          fundCodes: vm.formAddChoice.code
        }).then(res => {
          if (res.data.Result) {
            // 再添加基金
            vm.$http.get(vm.$apiPath.addSearchFund, {
              userCode: vm.userCode,
              groupCode: vm.formAddChoice.choiceType,
              fundCode: vm.formAddChoice.code
            }).then(res => {
              if (res.data.Result) {
                Message({
                  type: 'success',
                  message: res.data.Note,
                  duration: 2000
                });
              }
              vm.formAddChoice.code = '';
              vm.allData.forEach((val, ind) => {
                if (val.groupCode == vm.formAddChoice.choiceType) {
                  vm.getChoiceList(ind);
                  vm.getChoiceYield(ind);
                }
              })
            })
          }
        })
      } else {
        Message({
          type: 'warning',
          message: '请选择要添加的基金！',
          duration: 2000
        });
      }
    },

    // 获取自选分类  ---初始化
    getChoiceType () {
      const vm = this;
      vm.$http.get(vm.$apiPath.getChoiceType, {
        userCode: vm.userCode
      }).then(res => {
        if (res.data.Result) {
          if (res.data.Data && res.data.Data.length > 0) {
            vm.choiceTypeList = res.data.Data;
            vm.formAddChoice.choiceType = '0';
            vm.choiceTypeTable = res.data.Data;
            vm.choiceTypeTableCodes = [];
            vm.allData = [];
            // console.log(vm.choiceTypeTable);
            vm.choiceTypeTable.forEach((val, ind) => {
              vm.choiceTypeTableCodes.push(val.GroupCode);
              vm.allData.push({
                groupCode: val.GroupCode,  // 分类code
                groupName: val.GroupName,  // 分类name
                groupOthers: vm.choiceTypeTable.filter((v, i) => { return v.GroupCode != val.GroupCode }),  // 其他分类项
                fundChoice: 0,             // 基金概况0，业绩排名1
                fundProfile: [],           // 基金概况列表
                fundProfileSelect: [],     // 基金概况选中的列，保存基金代码
                fundProfilePage: 1,        // 基金概况页码
                fundProfilePageNum: 10,    // 基金概况分页数
                fundProfileTotal: 0,       // 基金概况列表总数
                fundRank: [],              // 业绩排名列表
                fundRankSelect: [],        // 业绩排行选中的列，保存基金代码
                fundRankPage: 1,           // 业绩排名页码
                fundRankPageNum: 10,       // 业绩排名分页数
                fundRankTotal: 0,          // 业绩排名列表总数
                fundRankFlag: 0,           // 业绩排名排序   flag  0：今年以来， 1：近1周， 2：近1月， 3：近3月，4：近6月， 5：近1年， 6：近2年， 7：近3年
                fundRankSort: 0,           // 业绩排名排序  sort为0 降序，sort为1 升序
              });
              vm.getChoiceList(ind);
              vm.getChoiceYield(ind);
            })
          } else {
            vm.$http.get(vm.$apiPath.addChoiceType, {
              userCode: vm.userCode,
              groupName: '默认'
            }).then(res => {
              if (res.data.Result) {
                vm.getChoiceType();
              }
            })
          }
        }
      })
    },
    // 新建自定义自选
    addChoiceItemSure () {
      const vm = this;
      if (vm.addChoiceItem) {
        let flag = true;
        vm.choiceTypeTable.forEach((val, ind) => {
          if (val.GroupName == vm.addChoiceItem) {
            flag = false;
            Message({
              type: 'warning',
              message: '该分类名称已存在，请重新命名！',
              duration: 2000
            });
          }
        });
        if (flag) {
          vm.$http.get(vm.$apiPath.addChoiceType, {
            userCode: vm.userCode,
            groupName: vm.addChoiceItem
          }).then(res => {
            if (res.data.Result) {
              Message({
                type: 'success',
                message: res.data.Note,
                duration: 2000
              });
              vm.addChoiceItem = '';
              vm.getChoiceType();
            }
          })
        }
      }
    },
    // 删除自选分类
    choiceTypeItemDel (row) {
      // console.log(row);
      const vm = this;
      vm.$confirm('确定删除"' + row.GroupName + '"?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        vm.$http.get(vm.$apiPath.delChoiceType, {
          userCode: vm.userCode,
          groupCode: row.GroupCode
        }).then(res => {
          if (res.data.Result) {
            Message({
              type: 'success',
              message: res.data.Note,
              duration: 2000
            });
            vm.getChoiceType();
          }
        })
      }).catch(() => {
        Message({
          type: 'info',
          message: '已取消删除',
          duration: 2000
        });
      });
    },
    // 更名
    choiceTypeItemEdit (row) {
      const vm = this;
      vm.dialogVisable1 = true;
      vm.choiceTypeItemCode = row.GroupCode;
      vm.choiceTypeItemName = row.GroupName;
    },
    choiceTypeItemEditSure () {
      const vm = this;
      if (vm.choiceTypeItemName) {
        let flag = true;
        vm.choiceTypeTable.forEach((val, ind) => {
          if (val.GroupName == vm.choiceTypeItemName) {
            flag = false;
            Message({
              type: 'warning',
              message: '该分类名称已存在，请重新命名！',
              duration: 2000
            });
          }
        });
        if (flag) {
          vm.$http.get(vm.$apiPath.editChoiceType, {
            userCode: vm.userCode,
            groupName: vm.choiceTypeItemName,
            groupCode: vm.choiceTypeItemCode,
          }).then(res => {
            if (res.data.Result) {
              Message({
                type: 'success',
                message: res.data.Note,
                duration: 2000
              });
              vm.dialogVisable1 = false;
              vm.getChoiceType();
            }
          })
        }
      }
    },
    // 上移
    moveUp (index) {
      // console.log('上移index',index);
      let temp = this.choiceTypeTableCodes[index];
      this.choiceTypeTableCodes[index] = this.choiceTypeTableCodes[index - 1];
      this.choiceTypeTableCodes[index - 1] = temp;
      this.moveFun();
    },
    // 下移
    moveDown (index) {
      // console.log('下移index',index);
      let temp = this.choiceTypeTableCodes[index];
      this.choiceTypeTableCodes[index] = this.choiceTypeTableCodes[index + 1];
      this.choiceTypeTableCodes[index + 1] = temp;
      this.moveFun();
    },
    moveFun () {
      const vm = this;
      // console.log(vm.choiceTypeTableCodes);
      vm.$http.get(vm.$apiPath.moveChoiceType, {
        userCode: vm.userCode,
        groupCodes: vm.choiceTypeTableCodes.join(',')
      }).then(res => {
        if (res.data.Result) {
          vm.getChoiceType();
        }
      })
    },

    // 获取自选列表_基金概况
    getChoiceList (index) {
      const vm = this;
      vm.$http.get(vm.$apiPath.getChoiceList, {
        userCode: vm.userCode,
        groupCode: vm.allData[index].groupCode,
        page: vm.allData[index].fundProfilePage,
        pageNum: vm.allData[index].fundProfilePageNum
      }).then(res => {
        if (res.data.Result) {
          // console.log('自选列表_基金概况', res.data);
          vm.allData[index].fundProfile = [];
          vm.allData[index].fundProfileTotal = res.data.recordCount;
          if (res.data.recordCount > 0) {
            res.data.Data.forEach((val, ind) => {
              vm.allData[index].fundProfile.push({
                fundCode: val.FundList[0],
                fundName: val.FundList[1],
                netValueDate: val.FundList[2],
                netWorth: val.FundList[3],
                estimatedIncrease: val.FundList[4],
                dailyGrowth: val.FundList[5],
                unitNet: val.FundList[6],
                accumulatedNet: val.FundList[7],
                yields: val.FundList[8],
                addDate: val.FundList[9]
              })
            })
          }
        }
      })
    },
    // 获取自选列表_业绩排名
    getChoiceYield (index) {
      const vm = this;
      vm.$http.get(vm.$apiPath.getChoiceYield, {
        userCode: vm.userCode,
        groupCode: vm.allData[index].groupCode,
        page: vm.allData[index].fundRankPage,
        pageNum: vm.allData[index].fundRankPageNum,
        flag: vm.allData[index].fundRankFlag,
        sort: vm.allData[index].fundRankSort
      }).then(res => {
        if (res.data.Result) {
          // console.log('自选列表_业绩排名',res.data);
          vm.allData[index].fundRank = [];
          vm.allData[index].fundRankTotal = res.data.recordCount;
          if (res.data.recordCount > 0) {
            res.data.Data.forEach((val, ind) => {
              vm.allData[index].fundRank.push({
                fundCode: val.FundList[0],
                fundName: val.FundList[1],
                sinceThisYear: val.FundList[2],
                oneWeek: val.FundList[3],
                oneMonth: val.FundList[4],
                threeMonth: val.FundList[5],
                sixMonth: val.FundList[6],
                oneYear: val.FundList[7],
                twoYear: val.FundList[8],
                threeYear: val.FundList[9]
              })
            })
          }
        }
      })
    },
    // 基金概况 操作：置顶
    goTopFun (index, groupCode, fundCode) {
      const vm = this;
      vm.$http.get(vm.$apiPath.goTopFund, {
        userCode: vm.userCode,
        groupCode: groupCode,
        fundCode: fundCode
      }).then(res => {
        if (res.data.Result) {
          vm.getChoiceList(index);
        }
      })
    },
    // 基金概况 操作：移动分类自选
    moveOtherGroup (command, fundCode, index, item) {
      const vm = this;
      // console.log(command,fundCode,index,item);
      // 1. 删除该分组下的这只基金
      vm.$http.get(vm.$apiPath.delFundCodes, {
        userCode: vm.userCode,
        groupCode: vm.allData[index].groupCode,
        fundCodes: fundCode
      }).then(res => {
        if (res.data.Result) {
          // 2. 重新获取该分组下的基金列表
          vm.allData[index].fundProfilePage = 1;
          vm.allData[index].fundRankPage = 1;
          vm.getChoiceList(index);
          vm.getChoiceYield(index);
        }
      });
      // 3. 移至的另一个分组中，先清除该基金已存在的情况
      vm.$http.get(vm.$apiPath.delFundCodes, {
        userCode: vm.userCode,
        groupCode: command.GroupCode,
        fundCodes: fundCode
      }).then(res => {
        if (res.data.Result) {
          // 再添加基金
          vm.$http.get(vm.$apiPath.addSearchFund, {
            userCode: vm.userCode,
            groupCode: command.GroupCode,
            fundCode: fundCode
          }).then(res => {
            vm.getChoiceList(command.GroupRank);
            vm.getChoiceYield(command.GroupRank);
          })
        }
      })
    },

    // 列表选择变化
    handleSelectionChange (index, fundChoice, val) {
      const vm = this;
      // console.log(index,fundChoice,val)
      if (fundChoice == 0) {  // 基金概况
        vm.allData[index].fundProfileSelect = [];
        if (val) {
          val.forEach((v, i) => {
            vm.allData[index].fundProfileSelect.push(v.fundCode);
          })
        }
      } else {    // 业绩排名
        vm.allData[index].fundRankSelect = [];
        if (val) {
          val.forEach((v, i) => {
            vm.allData[index].fundRankSelect.push(v.fundCode);
          })
        }
      }
    },
    // 基金概况/业绩分类 操作：删除,诊断
    optFunds (index, fundChoice, opt) {
      const vm = this;
      if (fundChoice == 0) {  // 基金概况
        if (vm.allData[index].fundProfileSelect.length > 0) {
          // console.log(vm.allData[index].fundProfileSelect.join(','));
          if (opt == 'delete') {  // 删除
            vm.delFunds(index, vm.allData[index].fundProfileSelect);
          } else if (opt == 'diagnosis') {  // 诊断
            vm.diagnosisFunds(index, vm.allData[index].fundProfileSelect);
          }
        } else {
          Message({
            type: 'warning',
            message: '请先选择基金！',
            duration: 2000
          });
        }
      } else {    // 业绩排名
        if (vm.allData[index].fundRankSelect.length > 0) {
          // console.log(vm.allData[index].fundRankSelect.join(','));
          if (opt == 'delete') {  // 删除
            vm.delFunds(index, vm.allData[index].fundRankSelect);
          } else if (opt == 'diagnosis') {  // 诊断
            vm.diagnosisFunds(index, vm.allData[index].fundRankSelect);
          }
        } else {
          Message({
            type: 'warning',
            message: '请先选择基金！',
            duration: 2000
          });
        }
      }
    },
    // 删除
    delFunds (index, arrCodes) {
      const vm = this;
      vm.$confirm('确定要删除选中的基金?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        vm.$http.get(vm.$apiPath.delFundCodes, {
          userCode: vm.userCode,
          groupCode: vm.allData[index].groupCode,
          fundCodes: arrCodes.join(',')
        }).then(res => {
          if (res.data.Result) {
            Message({
              type: 'success',
              message: res.data.Note,
              duration: 2000
            });
            vm.allData[index].fundProfilePage = 1;
            vm.allData[index].fundRankPage = 1;
            vm.getChoiceList(index);
            vm.getChoiceYield(index);
          }
        })
      }).catch(() => {
        Message({
          type: 'info',
          message: '已取消删除',
          duration: 2000
        });
      });
    },
    // 诊断
    diagnosisFunds (index, arrCodes) {
      let length = arrCodes.length;
      if (length == 1) {  // 单只诊断
        var p = window.location.protocol;  // 获取协议
        window.open(p + "//www.myfund.com/mutualSingleFundAnalysis/" + arrCodes[0] + ".html", "_blank");
      } else {   // 组合诊断
        Message({
          type: 'info',
          message: '组合诊断，开发中',
          duration: 2000
        });
      }
    },
    // 购买
    buyFunds (row) {
      this.$http.get(this.$apiPath.getChoiceFundStatus, {
        fundCode: row.fundCode
      }).then(res => {
        if (res.status !== 200) return
        if (res.data.Code == '1') {
          this.$router.push({ name: 'publicBuy', params: { fundcode: row.fundCode, pathName: 'myChoice' } })
        } else {
          this.$alert(row.fundName + '(' + row.fundCode + ') ' + res.data.StatusStr, '', {
            confirmButtonText: '确定',
          });
        }
      }).catch(err => { })
    },
    // 排序
    changeTableSort (column, index) {
      const vm = this;
      switch (column.prop) {
        case 'sinceThisYear':  // 今年以来
          vm.allData[index].fundRankFlag = 0;
          break;
        case 'oneWeek':  // 近1周
          vm.allData[index].fundRankFlag = 1;
          break;
        case 'oneMonth':  // 近1月
          vm.allData[index].fundRankFlag = 2;
          break;
        case 'threeMonth':  // 近3月
          vm.allData[index].fundRankFlag = 3;
          break;
        case 'sixMonth':  // 近6月
          vm.allData[index].fundRankFlag = 4;
          break;
        case 'oneYear':  // 近1年
          vm.allData[index].fundRankFlag = 5;
          break;
        case 'twoYear':  // 近2年
          vm.allData[index].fundRankFlag = 6;
          break;
        case 'threeYear':  // 近3年
          vm.allData[index].fundRankFlag = 7;
          break;
      }
      if (column.order == 'ascending') {
        vm.allData[index].fundRankSort = 1;
      } else {
        vm.allData[index].fundRankSort = 0;
      }
      vm.getChoiceYield(index);
    },

    // 分页处理
    handleCurrentChange (index, fundChoice, val) {
      const vm = this;
      if (fundChoice == 0) {   // 基金概况
        vm.allData[index].fundProfilePage = val;
        vm.getChoiceList(index);
      } else {  // 业绩排名
        vm.allData[index].fundRankPage = val;
        vm.getChoiceYield(index);
      }
    }
  }
}
</script>

<style lang="less" scoped>
.myChoicePublic {
  &-header {
    width: 100%;
    height: 90px;
    padding-top: 10px;
    position: relative;

    &-link {
      line-height: 32px;
      cursor: pointer;
    }
    &-link:hover {
      color: @color;
    }

    &-refresh {
      position: absolute;
      top: 30px;
      right: 115px;
      font-size: 16px;
      line-height: 32px;
      color: @color3;
      cursor: pointer;
      i {
        font-size: 18px;
        color: @color;
      }
      i.go {
        transform: rotate(360deg);
        transition: all 1s;
      }
    }
  }
  &-set {
    position: absolute;
    top: 30px;
    right: 0;
  }
  &-fontopt {
    margin-left: 20px;
    img {
      width: 24px;
      height: 24px;
      margin-left: 5px;
    }
    img.imgs {
      cursor: pointer;
    }
  }
  .dropdown-x {
    .el-dropdown-link {
      font-size: 14px;
      color: @color;
      cursor: pointer;
    }
  }
  .dropdown-x.font16 .el-dropdown-link {
    font-size: 16px;
  }
  .dropdown-x.font18 .el-dropdown-link {
    font-size: 18px;
  }
}
.el-dropdown-menu {
  border: 1px solid @color;
}
.common-box {
  min-height: 0;
}
</style>
